<template>
    <Page>
        <main>
            <Spinner :color="config.COLOR_PRIMARY"/>
        </main>
    </Page>
</template>
<script>
import { SolutionConsumer } from '../../mixins';
import { Page } from '../../components/shared';

export default {
    name: 'Loading',
    components: { Page },
    mixins: [SolutionConsumer],
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';

main {
    @include flex-vertical();
    flex-grow: 1;
    justify-content: center;
    align-items: center;
}
</style>
